<template>
  <el-card style="height: 695px;overflow-y: scroll;">
    <div class="region">
      <p>智能向导管理</p>

      <el-button type="primary" class="add_button" @click="dialogVisible = true">新增智能向导</el-button>
      <el-table border :data="tableData" :header-cell-style="{'background-color': '#f6f6f6'}"
                style="width: 100%;margin-top: 20px;">
        <el-table-column align="center" prop="title" label="标题"></el-table-column>
        <el-table-column align="center" prop="path" label="跳转路径"></el-table-column>
        <el-table-column align="center" prop="type" label="匹配类型"></el-table-column>
        <el-table-column align="center" prop="keyword" label="关键字"></el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button @click="editRegionShow(scope.row)" type="text" class="button">编辑</el-button>
            <el-button @click="deleteRegion(scope.row.id)" type="text" class="button">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :modal="false" class="dialog" :visible.sync="dialogVisible" :show-close="false"
                 @close="closeDialog" width="30%">
        <el-form :model="form">
          <el-form-item label="关键字">
            <el-input placeholder="请输入" style="width: 80%" v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="跳转链接">
            <el-select v-model="form.path" placeholder="请选择">
              <el-option label="上传其他信息" :value="0"></el-option>
              <el-option label="上传检验报告" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="匹配类型">
            <el-select v-model="form.type" placeholder="请选择">
              <el-option :label="key" :value="val" v-for="(val,key,index) in type_dict" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字">
            <el-select v-model="form.keys" placeholder="请选择" allow-create filterable default-first-option multiple>
              <el-option :label="item.name" :value="item.name" v-for="(item,index) in keys" :key="item.id"></el-option>
            </el-select>
          </el-form-item>

        </el-form>
        <el-row class="buttons" type="flex" align="middle" justify="end" style="margin-right: 30px;">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitRegionForm">确定</el-button>
        </el-row>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
import {
  get_intelligent_wizard,
  create_intelligent_wizard,
  edit_intelligent_wizard,
  delete_intelligent_wizard, get_intelligent_wizard_key
} from "@/api/IntelligentWizard";

export default {
  name: 'IntelligentWizardView',
  data: function () {
    return {
      tableData: [],
      form: {
        title: '',
        path: 0,
        type: 0,
        keys: [],
      },
      keys: [],
      type_dict: {
        '病历': 0,
        '影像学检查报告': 1,
        '实验室检验报告': 2,
        '其他': 3,
      },
      dialogVisible: false,
    }
  },
  methods: {
    getRegionData() {
      get_intelligent_wizard().then((res) => {
        const {data} = res
        if (data['code'] === 200) {
          this.tableData = data['data']
        }
      })
    },
    getSelect() {
      get_intelligent_wizard_key().then((res) => {
        const {data} = res
        if (data['code'] === 200) {
          this.keys = data['data']
        }
      })
    },
    closeDialog() {
      this.form = {
        title: '',
        path: 0,
        type: 0,
        keys: [],
      }
      this.dialogVisible = false
    },
    submitRegionForm() {
      let fn
      if (this.form.id) {
        fn = edit_intelligent_wizard
      } else {
        fn = create_intelligent_wizard
      }
      fn(this.form.title, this.form.path, this.form.type, this.form.keys, this.form.id).then((res) => {
        const {data} = res
        if (data['code'] === 200) {
          this.$message.success(data['message'])
          this.dialogVisible = false
          this.getSelect()
          this.getRegionData()
        } else {
          this.$message.error(data['error'])
        }
      })
    },
    editRegionShow(row) {
      this.form = row
      this.form.keys = row.keyword
      this.form.path = row.path === '/beckman/ARR/wizard/2' ? 0 : 1
      this.form.type = this.type_dict[row.type]
      this.dialogVisible = true
    },
    deleteRegion(id) {
      delete_intelligent_wizard(id).then(res => {
        const {data} = res
        if (data['code'] === 200) {
          this.$message.success('删除成功！')
          this.getRegionData()
        }
      })
    }
  },
  created() {
    this.getRegionData();
    this.getSelect()
  },
  computed: {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.el-card {
  width: 99%;
}
</style>